import React from 'react'
import { MarkerSvgProps } from './MarkerSvgProps'

export const HolidaySvg = ({ style }: MarkerSvgProps) => {
  return (
    <svg
      width="46"
      height="40"
      viewBox="0 0 46 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g opacity="0.35" filter="url(#filter0_f_8284_162961)">
        <path
          d="M31 34.5C31 35.8807 27.4183 37 23 37C18.5817 37 15 35.8807 15 34.5C15 33.1193 18.5817 32 23 32C27.4183 32 31 33.1193 31 34.5Z"
          fill="black"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.599609 5.0001C0.599609 2.57005 2.56956 0.600098 4.99961 0.600098H40.9996C43.4297 0.600098 45.3996 2.57004 45.3996 5.0001V25.0001C45.3996 27.4301 43.4297 29.4001 40.9996 29.4001H28.0058L24.9526 33.6746C23.9954 35.0146 22.0038 35.0146 21.0466 33.6746L17.9934 29.4001H4.99961C2.56956 29.4001 0.599609 27.4302 0.599609 25.0001V5.0001ZM1.99961 5.0001C1.99961 3.34324 3.34276 2.0001 4.99961 2.0001H40.9996C42.6565 2.0001 43.9996 3.34324 43.9996 5.0001V25.0001C43.9996 26.6569 42.6565 28.0001 40.9996 28.0001H27.7999C27.477 28.0001 27.1739 28.1561 26.9862 28.4189L23.8133 32.8609C23.4145 33.4192 22.5847 33.4192 22.1859 32.8609L19.013 28.4189C18.8253 28.1561 18.5222 28.0001 18.1993 28.0001H4.99961C3.34276 28.0001 1.99961 26.657 1.99961 25.0001V5.0001Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 2C3.34315 2 2 3.34315 2 5V25C2 26.6569 3.34315 28 5 28H18.1997C18.5226 28 18.8257 28.156 19.0134 28.4188L22.1863 32.8608C22.5851 33.4191 23.4149 33.4191 23.8137 32.8608L26.9866 28.4188C27.1743 28.156 27.4774 28 27.8003 28H41C42.6569 28 44 26.6569 44 25V5C44 3.34315 42.6569 2 41 2H5Z"
        fill="#FFF6F5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 3C3.89543 3 3 3.89543 3 5V25C3 26.1046 3.89543 27 5 27H18.1997C18.8456 27 19.4517 27.3119 19.8271 27.8375L23 32.2795L26.1729 27.8375C26.5483 27.3119 27.1544 27 27.8003 27H41C42.1046 27 43 26.1046 43 25V5C43 3.89543 42.1046 3 41 3H5ZM2 5C2 3.34315 3.34315 2 5 2H41C42.6569 2 44 3.34315 44 5V25C44 26.6569 42.6569 28 41 28H27.8003C27.4774 28 27.1743 28.156 26.9866 28.4188L23.8137 32.8608C23.4149 33.4191 22.5851 33.4191 22.1863 32.8608L19.0134 28.4188C18.8257 28.156 18.5226 28 18.1997 28H5C3.34315 28 2 26.6569 2 25V5Z"
        fill="#D43A71"
      />
      <path
        d="M16.46 14.1321V12.7401H13.328V10.0281H11.912V12.7401H8.86397V14.1321H11.348C10.652 15.8361 9.57197 17.5041 8.38397 18.4761V12.8841C8.86397 12.0681 9.28397 11.1921 9.61997 10.3521L8.20397 9.89614C7.53197 11.6841 6.37997 13.4121 5.16797 14.5041C5.41997 14.8521 5.85197 15.6561 5.99597 16.0041C6.33197 15.6921 6.65597 15.3201 6.97997 14.9241V21.0201H8.38397V18.6201C8.70797 18.9081 9.12797 19.3641 9.35597 19.6761C10.328 18.7761 11.216 17.4921 11.912 16.0401V21.0441H13.328V15.8001C13.976 17.3121 14.816 18.6921 15.752 19.6161C15.992 19.2441 16.472 18.7281 16.82 18.4761C15.68 17.4921 14.636 15.8361 13.952 14.1321H16.46Z"
        fill="#D43A71"
      />
      <path
        d="M24.944 13.9761L24.176 14.4921C24.392 14.6481 24.62 14.8281 24.848 15.0201L21.764 15.0801C21.98 14.7321 22.22 14.3481 22.436 13.9761H24.944ZM26.828 11.9121V12.7641H19.148V11.9121H26.828ZM23.696 19.4481V18.5241H27.392V17.3001H23.696V16.2561L26.132 16.1841C26.36 16.4241 26.564 16.6521 26.72 16.8561L27.836 16.0761C27.332 15.4641 26.324 14.6121 25.46 13.9761H26.96V13.1121H28.28V10.6161H23.696V9.84814H22.232V10.6161H17.756V13.1121H19.076V13.9761H20.804C20.648 14.3481 20.456 14.7441 20.276 15.1041L18.572 15.1281L18.632 16.4001C19.628 16.3761 20.888 16.3401 22.232 16.3041V17.3001H18.788V18.5241H22.232V19.4481H17.72V20.7081H28.352V19.4481H23.696Z"
        fill="#D43A71"
      />
      <path
        d="M32.336 18.6801V15.9921H37.664V18.6801H32.336ZM37.664 11.9961V14.5761H32.336V11.9961H37.664ZM30.86 10.5561V20.9001H32.336V20.1201H37.664V20.8761H39.2V10.5561H30.86Z"
        fill="#D43A71"
      />
      <defs>
        <filter
          id="filter0_f_8284_162961"
          x="12"
          y="29"
          width="22"
          height="11"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1.5"
            result="effect1_foregroundBlur_8284_162961"
          />
        </filter>
      </defs>
    </svg>
  )
}
